<template>
  <div class="white-bg">
    <div class="header">
      <h2>
        <strong>{{ $t('auth.register.title') }}</strong>
      </h2>
    </div>
    <b-row>
      <b-form-group class="col-xl-6">
        <b-form-input
        id="given-names"
        type="text"
        name="given-names"
        :state="givenNamesState"
        v-model="givenNames"
        :placeholder="$t('auth.register.givenNamesHolder')"
        aria-describedby="givenNamesFeedB"
        ></b-form-input>
        <b-form-invalid-feedback id="givenNamesFeedB" class="align-left">
          {{ $t('auth.register.givenNamesFeedB') }}
        </b-form-invalid-feedback>
      </b-form-group>
      
      <b-form-group class="col-xl-6">
        <b-form-input
        id="last-names"
        type="text"
        name="last-names"
        :state="lastNamesState"
        v-model="lastNames"
        :placeholder="$t('auth.register.lastNamesHolder')"
        aria-describedby="lastNamesFeedB"
        ></b-form-input>
        <b-form-invalid-feedback id="lastNamesFeedB" class="align-left">
          {{ $t('auth.register.lastNamesFeedB') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-row>

    <b-form-group>
      <b-form-input
        id="username"
        type="email"
        name="username"
        :state="usernameState"
        v-model="username"
        :placeholder="$t('auth.register.emailHolder')"
        aria-describedby="usernameFeedback"
      ></b-form-input>
      <b-form-invalid-feedback id="usernameFeedback" class="align-left">
        {{ $t('auth.register.emailFeedB') }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <b-form-input
        id="password"
        type="password"
        name="password"
        :state="passwordState"
        v-model="password"
        :placeholder="$t('auth.register.passwdHolder')"
      ></b-form-input>
      <b-form-group class="mb-0" v-if="!passwordState">
        <b-form-invalid-feedback
          id="passwordFeedback"
          class="align-left"
          :state="passwordMinState"
        >
          {{ $t('auth.register.passwdFeedMin') }}
        </b-form-invalid-feedback>
        <b-form-valid-feedback
          id="passwordFeedback"
          class="align-left"
          :state="passwordMinState"
        >
          {{ $t('auth.register.passwdFeedMin') }}
        </b-form-valid-feedback>
        <b-form-invalid-feedback
          id="passwordUpperCaseFeedback"
          class="align-left"
          :state="passwordUpperCaseState"
        >
          {{ $t('auth.register.passwdFeedUpper') }}
        </b-form-invalid-feedback>
        <b-form-valid-feedback
          id="passwordUpperCaseFeedback"
          class="align-left"
          :state="passwordUpperCaseState"
        >
          {{ $t('auth.register.passwdFeedUpper') }}
        </b-form-valid-feedback>
        <b-form-invalid-feedback
          id="passwordLowerCaseFeedback"
          class="align-left"
          :state="passwordLowerCaseState"
        >
          {{ $t('auth.register.passwdFeedLower') }}
        </b-form-invalid-feedback>
        <b-form-valid-feedback
          id="passwordLowerCaseFeedback"
          class="align-left"
          :state="passwordLowerCaseState"
        >
          {{ $t('auth.register.passwdFeedLower') }}
        </b-form-valid-feedback>
        <b-form-invalid-feedback
          id="passwordNumberFeedback"
          class="align-left"
          :state="passwordNumberState"
        >
          {{ $t('auth.register.passwdFeedNumber') }}
        </b-form-invalid-feedback>
        <b-form-valid-feedback
          id="passwordNumberFeedback"
          class="align-left"
          :state="passwordNumberState"
        >
          {{ $t('auth.register.passwdFeedNumber') }}
        </b-form-valid-feedback>
        <b-form-invalid-feedback
          id="passwordFeedback"
          class="align-left"
          :state="passwordCharState"
        >
          {{ $t('auth.register.passwdFeedChar') }}
        </b-form-invalid-feedback>
        <b-form-valid-feedback
          id="passwordFeedback"
          class="align-left"
          :state="passwordCharState"
        >
          {{ $t('auth.register.passwdFeedChar') }}
        </b-form-valid-feedback>
      </b-form-group>
    </b-form-group>

    <b-form-group>
      <b-form-input
        id="confirmPassword"
        type="password"
        name="confirmPassword"
        :state="confirmPasswordState"
        v-model="confirmPassword"
        :placeholder="$t('auth.register.reEnterHolder')"
        aria-describedby="confirmPasswordFeedback"
      ></b-form-input>
      <b-form-invalid-feedback
        id="confirmPasswordFeedback"
        class="align-left"
      >
        {{ $t('auth.register.reEnterFeedB') }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <b-form-input
        id="phone"
        type="tel"
        name="phone"
        :state="phoneState"
        v-model="phone"
        :placeholder="$t('auth.register.phoneHolder')"
        aria-describedby="phoneFeedback"
      ></b-form-input>
      <b-form-invalid-feedback
        id="phoneFeedback"
        class="align-left"
      >
        {{ $t('auth.register.phoneFeedB') }}
      </b-form-invalid-feedback>
    </b-form-group>

    <vue-recaptcha @verify="onVerify" @expired="onExpired" :sitekey="recaptchaKey"></vue-recaptcha>
    <p class="info align-left">
      {{ $t('auth.register.captcha') }}
    </p>

    <div class="modal-bottom"></div>

    <b-btn class="register-button" @click="registerClicked()" :disabled="!checkState">
      {{ $t('auth.register.registerBtn') }}
    </b-btn>

    <p class="register-class" @click="loginNavigation()">
      {{ $t('auth.register.loginLink') }}
    </p>
    <div class="modal-bottom"></div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import Config from '@/config.json';
import AccountMixin from '../../services/AccountMixin';

export default {
  name: 'RegisterComponent',
  components: {
    VueRecaptcha
  },
  data() {
    return {
      username: '',
      password: '',
      confirmPassword: '',
      phone: '',
      givenNames: '',
      lastNames: '',

      recaptchaKey: '',
      captchaResp: ''

    };
  },

  mixins: [AccountMixin],

  created() {
    this.recaptchaKey = Config.RECAPTCHA;
  },

  methods: {
    async onVerify(response) {
      this.captchaResp = response;
    },

    onExpired() {
      // this.resetRecaptcha();
      this.captchaResp = '';
    },

    registerClicked() {
      if (this.validForm()) {
        this.$emit('register', {
          email: this.username,
          password: this.password,
          phone: this.phone,
          givenNames: this.givenNames,
          lastNames: this.lastNames,
          recaptcha: this.captchaResp
        });
      }
    },

    loginNavigation() {
      this.$emit('loginNav');
    },

    validForm() {
      return this.usernameState
        && this.passwordState
        && this.confirmPasswordState
        && this.phoneState
        && this.givenNamesState
        && this.lastNamesState
        && this.captchaResp.length > 0;
    }
  },

  computed: {
    usernameState() {
      return this.getUsernameState(this.username);
    },

    passwordState() {
      return this.getPasswordState(this.password);
    },

    passwordMinState() {
      return this.getPasswordMinState(this.password);
    },

    passwordUpperCaseState() {
      return this.getPasswordUpperCaseState(this.password);
    },

    passwordLowerCaseState() {
      return this.getPasswordLowerCaseState(this.password);
    },

    passwordNumberState() {
      return this.getPasswordNumberState(this.password);
    },

    passwordCharState() {
      return this.getPasswordCharState(this.password);
    },

    confirmPasswordState() {
      return this.getConfirmPasswordState(this.password, this.confirmPassword);
    },

    phoneState() {
      return this.getPhoneState(this.phone);
    },

    givenNamesState() {
      return this.getGivenNamesState(this.givenNames);
    },

    lastNamesState() {
      return this.getLastNamesState(this.lastNames);
    },

    checkState() {
      return this.validForm();
    }
  }
};
</script>

<style lang="scss">
.register-button {
  width: 100%;
  background-image: linear-gradient(to right, #136a8a, #267871) !important;
}

.register-button:disabled {
  width: 100%;
  background-image: linear-gradient(to right, #B5B5B5, #B5B5B5) !important;
}

.register-class {
  padding-top: 20px;
  cursor: pointer;
}
</style>
